import React, {useState, useMemo} from 'react';

import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import CircularProgress from '@material-ui/core/CircularProgress';

import NewEvent from '../../../components/Forms/NewEvent';
import NewTransfer from '../../../components/Forms/NewTransfer';
import Confirmation from '../../../components/Forms/Confirmation';
import useStyles from '../../styles';
import {withData} from '../../../containers/DataContainer';

import Description from './Description';

const Details = withData(({
  path,
  data,
  setPath,
  rowData,
  isDetailBusy,
  deleteSlot,
  _updateDeliveryStatus,
  _deleteDelivery,
  _createEvent,
  _createTransfer,
  isBusy,
  fetchData
}) => {

  const classes = useStyles();

  const [_isBusy, setBusy] = useState(false);

  const _deleteSlot = async data => {
    setBusy(true);
    await deleteSlot(data);
    await fetchData();
    setPath('root');
    setBusy(false);
  };

  const onClose = async () => {
    // do not await... close the modal and await outside it
    // fetchData();
    setPath('root');
  };

  const memoEvent = useMemo(() =>
    <NewEvent
      onClose={() => setPath('root')}
      onSubmit={_createEvent}
    />, [_createEvent, setPath]
  );

  const memoTransfer = useMemo(() =>
    <NewTransfer
      onClose={() => setPath('root')}
      onSubmit={_createTransfer}
      meta={data.meta}
    />, [_createTransfer, setPath, data.meta]
  );

  const Switch = () => {
    switch (path) {
      case 'update': return <Confirmation
        message='Gostaria de atualizar o status da pré carga para "Terminado"?'
        isBusy={isDetailBusy}
        onSubmit={_updateDeliveryStatus}
        onClose={onClose}
      />;
      case 'delete': return <Confirmation
        message='Gostaria de apagar permanentemente este item?'
        isBusy={isDetailBusy}
        onSubmit={_deleteDelivery}
        onClose={onClose}
      />;
      case 'event': return memoEvent;
      case 'transfer': return memoTransfer;
      case 'detail': return <Description
        data={rowData}
        fetchData={fetchData}
        onClose={onClose}
        onEvent={() => setPath('event')}
        onTransfer={() => setPath('transfer')}
        onUpdate={() => setPath('update')}
        onDelete={() => setPath('delete')}
        createEvent={_createEvent}
        deleteSlot={_deleteSlot}
        isBusy={isBusy || _isBusy || isDetailBusy}
      />;
      default: return <CircularProgress/>;
    }
  };

  return <Dialog
    open={path !== 'root' && path !== 'new'}
    onClose={onClose}
    maxWidth='xl'
    fullWidth={path === 'detail'}
    scroll='body'
  >
    <Paper className={classes.dialog}>
      <Grid container justify='center' alignItems='center'>
        <Switch/>
      </Grid>
    </Paper>
  </Dialog>;
});

export default Details;
